/* GG Hobby — interactions */
(function () {
  "use strict";

  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- sticky nav state ---------- */
  var nav = document.getElementById("nav");
  function onScroll() {
    nav.classList.toggle("is-scrolled", window.scrollY > 8);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu ---------- */
  var burger = document.getElementById("navBurger");
  var links = document.getElementById("navLinks");

  function setMenu(open) {
    links.classList.toggle("is-open", open);
    burger.classList.toggle("is-open", open);
    burger.setAttribute("aria-expanded", open ? "true" : "false");
    burger.setAttribute("aria-label", open ? tr("Close menu") : tr("Open menu"));
  }

  burger.addEventListener("click", function () {
    var open = !links.classList.contains("is-open");
    setMenu(open);
    if (open) {
      // wait a frame so the drawer's visibility transition starts and links become focusable
      setTimeout(function () {
        var first = links.querySelector("a");
        if (first) first.focus();
      }, 120);
    }
  });

  links.addEventListener("click", function (e) {
    if (e.target.tagName === "A") setMenu(false);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && links.classList.contains("is-open")) {
      setMenu(false);
      burger.focus();
    }
  });

  /* ---------- scroll reveal ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !prefersReducedMotion) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- count-up stats ---------- */
  var counters = document.querySelectorAll(".count");
  function animateCount(el) {
    var target = parseFloat(el.dataset.count);
    var decimals = parseInt(el.dataset.decimals || "0", 10);
    var duration = 1400;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if ("IntersectionObserver" in window && !prefersReducedMotion) {
    var cio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            cio.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- open-now pill (verified hours: open 7 days, 11am-6pm ET) ---------- */
  var pill = document.getElementById("openPill");
  if (pill) {
    try {
      var parts = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
        hour12: false
      }).formatToParts(new Date());
      var get = function (type) {
        var p = parts.filter(function (x) { return x.type === type; })[0];
        return p ? p.value : "";
      };
      var mins = parseInt(get("hour"), 10) * 60 + parseInt(get("minute"), 10);
      var isOpen = mins >= 660 && mins < 1080; // 11:00-18:00, 7 days a week
      pill.hidden = false;
      if (isOpen) {
        pill.className = "open-pill open-pill--open";
        pill.textContent = tr("Open now · closes 6pm");
      } else {
        pill.className = "open-pill open-pill--closed";
        pill.textContent = tr("Closed · we're live online");
      }
    } catch (e) { /* leave pill hidden if Intl is unavailable */ }
  }

  /* ---------- drop countdown bands (Pitch Black 7/17, 30th Celebration 9/16, ...) ----------
     Any .pbband__count[data-until] ticks down; at zero it hides and swaps the band's
     title/sub to data-done-title / data-done-sub. Digits are the <b> elements in order. */
  Array.prototype.forEach.call(document.querySelectorAll(".pbband__count[data-until]"), function (cd) {
    var until = new Date(cd.getAttribute("data-until") || 0).getTime();
    var band = cd.closest(".pbband");
    var bs = cd.querySelectorAll("b");
    var title = band ? band.querySelector(".pbband__title") : null;
    var sub = band ? band.querySelector(".pbband__sub") : null;
    var tick = function () {
      var left = until - Date.now();
      if (left <= 0) {
        cd.style.display = "none";
        var dt = cd.getAttribute("data-done-title");
        var ds = cd.getAttribute("data-done-sub");
        if (title && dt) title.innerHTML = dt;
        if (sub && ds) sub.textContent = ds;
        return true;
      }
      var s = Math.floor(left / 1000);
      if (bs[0]) bs[0].textContent = String(Math.floor(s / 86400));
      if (bs[1]) bs[1].textContent = ("0" + Math.floor((s % 86400) / 3600)).slice(-2);
      if (bs[2]) bs[2].textContent = ("0" + Math.floor((s % 3600) / 60)).slice(-2);
      if (bs[3]) bs[3].textContent = ("0" + (s % 60)).slice(-2);
      return false;
    };
    if (!tick()) { var t = setInterval(function () { if (tick()) clearInterval(t); }, 1000); }
  });

  /* ---------- band frames: rotate the factory renders + swap the caption ---------- */
  Array.prototype.forEach.call(document.querySelectorAll(".pbband__frame"), function (frame) {
    var imgs = frame.querySelectorAll("img");
    if (imgs.length < 2) return;
    var fig = frame.closest("figure");
    var cap = fig ? fig.querySelector("figcaption") : null;
    var cur = 0;
    setInterval(function () {
      imgs[cur].classList.remove("is-on");
      cur = (cur + 1) % imgs.length;
      imgs[cur].classList.add("is-on");
      if (cap) {
        var c = imgs[cur].getAttribute("data-caption");
        if (c) cap.textContent = c;
      }
    }, 5000);
  });

  /* ---------- shop gallery: drag / swipe / arrows + gentle auto-drift when idle ----------
     (was a CSS marquee nobody could grab — now a real scroller; the duplicate photo set
     makes the loop seamless: scroll position wraps at the halfway point) ---------- */
  var gal = document.getElementById("galStrip");
  if (gal) {
    var galPause = 0;
    var galHold = function (ms) { galPause = Date.now() + ms; };
    var galWrap = function () {
      var h = gal.scrollWidth / 2;
      if (h > gal.clientWidth) {
        if (gal.scrollLeft >= h) gal.scrollLeft -= h;
        else if (gal.scrollLeft <= 0 && galPause > Date.now()) { /* let manual reach 0 naturally */ }
      }
    };
    if (!prefersReducedMotion) {
      setInterval(function () {
        if (Date.now() < galPause) return;
        gal.scrollLeft += 1;
        galWrap();
      }, 30);
    }
    gal.addEventListener("scroll", galWrap, { passive: true });
    gal.addEventListener("mouseenter", function () { galHold(2500); });
    gal.addEventListener("wheel", function () { galHold(3500); }, { passive: true });
    gal.addEventListener("touchmove", function () { galHold(3500); }, { passive: true });
    // drag-to-scroll with the mouse
    var galDrag = false, galX = 0, galL = 0;
    gal.addEventListener("mousedown", function (e) {
      galDrag = true; galX = e.pageX; galL = gal.scrollLeft; galHold(4000); e.preventDefault();
    });
    window.addEventListener("mousemove", function (e) {
      if (!galDrag) return;
      gal.scrollLeft = galL - (e.pageX - galX);
      galHold(4000);
    });
    window.addEventListener("mouseup", function () { galDrag = false; });
    var galStep = function (dir) {
      galHold(4500);
      gal.scrollBy({ left: dir * Math.round(gal.clientWidth * 0.7), behavior: "smooth" });
    };
    var galPrev = document.getElementById("galPrev"), galNext = document.getElementById("galNext");
    if (galPrev) galPrev.addEventListener("click", function () { galStep(-1); });
    if (galNext) galNext.addEventListener("click", function () { galStep(1); });
  }

  /* ---------- mobile sticky live bar: hide while the live section is on screen ---------- */
  var livebar = document.getElementById("livebar");
  var liveSection = document.getElementById("live");
  if (livebar && liveSection && "IntersectionObserver" in window) {
    var lio = new IntersectionObserver(function (entries) {
      livebar.classList.toggle("is-hidden", entries[0].isIntersecting);
    }, { threshold: 0.05 });
    lio.observe(liveSection);
  }

  /* ---------- lazy-load TikTok + Instagram embeds when they approach the viewport ---------- */
  var embedBlock = document.querySelector(".live__embed");
  if (embedBlock) {
    var loadEmbeds = function () {
      if (!document.querySelector('script[src*="tiktok.com/embed.js"]')) {
        var t = document.createElement("script");
        t.async = true;
        t.src = "https://www.tiktok.com/embed.js";
        document.body.appendChild(t);
      }
      if (document.querySelector(".instagram-media")) {
        if (!document.querySelector('script[src*="instagram.com/embed.js"]')) {
          var ig = document.createElement("script");
          ig.async = true;
          ig.src = "https://www.instagram.com/embed.js";
          ig.onload = function () { if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process(); };
          document.body.appendChild(ig);
        } else if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        }
      }
    };
    if ("IntersectionObserver" in window) {
      var eio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          loadEmbeds();
          eio.disconnect();
        }
      }, { rootMargin: "600px 0px" });
      eio.observe(embedBlock);
    } else {
      loadEmbeds();
    }
    // safety net: load on first user scroll, and unconditionally after a short delay
    var onScrollOnce = function () { loadEmbeds(); window.removeEventListener("scroll", onScrollOnce); };
    window.addEventListener("scroll", onScrollOnce, { passive: true });
    setTimeout(loadEmbeds, 2500);
  }

  /* ---------- horizontal scrollers: arrow buttons ---------- */
  function wireScroller(gridId, prevId, nextId) {
    var grid = document.getElementById(gridId);
    if (!grid) return;
    var step = function () {
      var first = grid.children[0];
      return first ? first.getBoundingClientRect().width + 20 : 320;
    };
    var prev = document.getElementById(prevId), next = document.getElementById(nextId);
    if (prev) prev.addEventListener("click", function () { grid.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { grid.scrollBy({ left: step(), behavior: "smooth" }); });
  }
  wireScroller("socialGrid", "socialPrev", "socialNext");
  wireScroller("dropsGrid", "dropsPrev", "dropsNext");

  /* ---------- gentle auto-drift for the social carousel ----------
     Slow ping-pong scroll so the channel cards move on their own (same energy as the photo
     strip). Pauses while the visitor hovers, touches, scrolls, or tabs into an embed, then
     resumes after a short idle. Skipped entirely for reduced-motion users. */
  (function autoDrift() {
    var grid = document.getElementById("socialGrid");
    if (!grid || prefersReducedMotion) return;
    var dir = 1, paused = false, resumeTimer = null, pos = null;
    function pauseFor(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; pos = null; }, ms);
    }
    grid.addEventListener("pointerenter", function () { paused = true; clearTimeout(resumeTimer); });
    grid.addEventListener("pointerleave", function () { pauseFor(1500); });
    ["pointerdown", "touchstart", "wheel", "focusin"].forEach(function (ev) {
      grid.addEventListener(ev, function () { pauseFor(5000); }, { passive: true });
    });
    (function step() {
      if (!paused && grid.scrollWidth > grid.clientWidth + 4) {
        // float accumulator (scrollLeft rounds to ints); resync if the visitor scrolled
        if (pos === null || Math.abs(grid.scrollLeft - pos) > 2) pos = grid.scrollLeft;
        pos += 0.45 * dir;
        grid.scrollLeft = pos;
        if (pos + grid.clientWidth >= grid.scrollWidth - 1) dir = -1;
        else if (pos <= 0) dir = 1;
      }
      requestAnimationFrame(step);
    })();
  })();

  /* ---------- self-heal product/league images if a lazy-load transiently fails ---------- */
  Array.prototype.forEach.call(document.querySelectorAll(".drop__media img, .lcard__img"), function (img) {
    img.addEventListener("error", function () {
      if (img.dataset.healed) return;
      img.dataset.healed = "1";
      var base = img.src.split("?")[0];
      setTimeout(function () { img.src = base + "?r=" + Date.now(); }, 500);
    });
  });

  /* ---------- hero card parallax + holo-foil shader ---------- */
  var hero = document.querySelector(".hero");
  var cards = document.querySelectorAll(".holo-card");
  if (hero && cards.length && !prefersReducedMotion) {
    var applyHolo = function (x, y) {
      // x, y in -0.5..0.5
      cards.forEach(function (card) {
        var depth = parseFloat(card.dataset.depth || "15");
        card.style.transform =
          "translate(" + (-x * depth) + "px, " + (-y * depth) + "px) " +
          "rotateY(" + (x * 16) + "deg) rotateX(" + (-y * 12) + "deg)";
        card.style.setProperty("--foil-x", (50 + x * 90) + "%");
        card.style.setProperty("--foil-y", (50 + y * 90) + "%");
        card.style.setProperty("--foil-o", "1");
      });
    };
    var resetHolo = function () {
      cards.forEach(function (card) {
        card.style.transform = "";
        card.style.setProperty("--foil-o", "0");
      });
    };
    if (window.matchMedia("(pointer: fine)").matches) {
      hero.addEventListener("mousemove", function (e) {
        var r = hero.getBoundingClientRect();
        if (!r.width || !r.height) return;
        applyHolo((e.clientX - r.left) / r.width - 0.5, (e.clientY - r.top) / r.height - 0.5);
      });
      hero.addEventListener("mouseleave", resetHolo);
    } else {
      // touch devices: tilt with finger drag over the hero
      hero.addEventListener("touchmove", function (e) {
        if (!e.touches.length) return;
        var r = hero.getBoundingClientRect();
        if (!r.width || !r.height) return;
        applyHolo((e.touches[0].clientX - r.left) / r.width - 0.5, (e.touches[0].clientY - r.top) / r.height - 0.5);
      }, { passive: true });
      hero.addEventListener("touchend", resetHolo);
    }
  }

  /* ---------- rolling sealed product (Jorge: boxes, not cards): the hero deals through
     factory renders — Pitch Black, 151 UPC, Charizard SPC, One Piece, Panini/Topps/UFC hobby
     boxes. Deck entries are filenames next to box-pitchblack.jpg; works on the static site
     (assets/grails/products/x) and on Shopify (CDN grails-products-x.jpg?v=…) by templating
     off the first slot's src. Missing files are probed and skipped. ---------- */
  if (cards.length && !prefersReducedMotion) {
    var DECK = ["box-pitchblack.jpg", "box-prizm-basketball.jpg", "box-op13.jpg", "box-topps-chrome-mlb.jpg", "box-flawless.jpg", "box-151-upc.jpg", "box-topps-chrome-basketball.jpg", "box-prizm-ufc.jpg", "box-charizard-spc.jpg", "box-bowman-chrome.jpg", "box-panini-nfl.jpg", "box-prizm-world-cup.jpg", "box-mega-evolution.jpg", "box-topps-ufc.jpg", "box-pb-booster.jpg", "box-prismatic.jpg"];
    var img0 = cards[0].querySelector("img");
    var tpl = img0 ? img0.getAttribute("src") : "";
    if (tpl && tpl.indexOf("box-pitchblack.jpg") !== -1) {
      var cardUrl = function (name) { return tpl.replace("box-pitchblack.jpg", name); };
      var loadedDeck = {};
      var waiting = DECK.length;
      var deckReady = function () {
        var pool = [];
        for (var di = 0; di < DECK.length; di++) { if (loadedDeck[DECK[di]]) pool.push(DECK[di]); }
        if (pool.length <= cards.length) return; // not enough cards to roll
        cards.forEach(function (card, i) {
          var im = card.querySelector("img");
          if (im) im.src = cardUrl(pool[i % pool.length]);
        });
        var dealt = cards.length;
        var slot = 0;
        setInterval(function () {
          var card = cards[slot % cards.length];
          slot++;
          var im = card.querySelector("img");
          if (!im) return;
          var next = cardUrl(pool[dealt % pool.length]);
          dealt++;
          card.classList.add("is-rolling");
          setTimeout(function () {
            im.src = next;
            card.classList.remove("is-rolling");
          }, 380);
        }, 3600);
      };
      DECK.forEach(function (name) {
        var probe = new Image();
        probe.onload = function () { loadedDeck[name] = true; if (--waiting === 0) deckReady(); };
        probe.onerror = function () { if (--waiting === 0) deckReady(); };
        probe.src = cardUrl(name);
      });
    }
  }

  /* ---------- Vault pipeline note: section stays hidden until first pull photos land ---------- */

  /* ---------- pre-launch: shop not live yet — soften every /collections link so nothing 404s.
     Flip window.GG_SHOP_LIVE = true (index.html / theme.liquid) once the POS publishes to Shopify. ---------- */
  if (window.GG_SHOP_LIVE === false) {
    Array.prototype.forEach.call(
      document.querySelectorAll('a[href^="/collections"], a[href^="/products"]'),
      function (a) {
        a.removeAttribute("href");
        a.setAttribute("aria-disabled", "true");
        if (a.classList.contains("btn")) {
          a.classList.add("btn--soon");
          a.textContent = tr("Dropping Soon");
        } else if (a.classList.contains("lcard")) {
          a.classList.add("is-soon");
          var em = a.querySelector(".lcard__label em");
          if (em) em.textContent = tr("Dropping soon");
        } else {
          a.classList.add("link-soon");
        }
      }
    );
  }

  /* ---------- shop LIVE: per-category gating. The vault grid links all nine
     collections, but only stocked ones should invite a click — an empty
     Shopify collection page is a dead end. Each card probes its own
     collection (public products.json, 1 item) and dims to "Coming soon"
     until products exist, so categories unlock themselves the moment the
     POS publishes into them — no rebuild, no hand-editing. Fail-open: if
     the probe errors (static preview, network), the card stays clickable. */
  if (window.GG_SHOP_LIVE === true) {
    Array.prototype.forEach.call(
      document.querySelectorAll('a.lcard[href^="/collections/"]'),
      function (a) {
        var m = /^\/collections\/([a-z0-9-]+)$/.exec(a.getAttribute("href") || "");
        if (!m || m[1] === "all") return;
        fetch("/collections/" + m[1] + "/products.json?limit=1", { credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j) return; // 404 = collection missing — leave the card alone (fail-open)
            if (!j.products || j.products.length === 0) {
              a.removeAttribute("href");
              a.setAttribute("aria-disabled", "true");
              a.classList.add("is-soon");
              var em = a.querySelector(".lcard__label em");
              if (em) em.textContent = tr("Coming soon");
            }
          })
          .catch(function () { /* fail-open */ });
      }
    );
  }
})();

// ---- Animated crew avatars (Avatar Studio) ----
// Overlays a looping idle clip on each crew card; if the clip is missing the
// original still stays. Works on the static site (assets/hosts/sin.jpg) and on
// Shopify (CDN hosts-sin.jpg?v=...) — the mp4 sits next to the jpg either way.
(function () {
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;
  document.querySelectorAll(".crew-card__media").forEach(function (media) {
    var img = media.querySelector('img[src*="hosts/"], img[src*="hosts-"]');
    if (!img) return;
    var src = img.getAttribute("src").replace(/\.(jpe?g|png)(\?.*)?$/i, ".mp4");
    if (!/\.mp4$/i.test(src)) return;
    var v = document.createElement("video");
    v.muted = true; v.loop = true; v.autoplay = true;
    v.setAttribute("playsinline", ""); v.setAttribute("preload", "metadata");
    v.poster = img.src; v.src = src;
    v.addEventListener("loadeddata", function () { v.classList.add("is-ready"); }, { once: true });
    v.addEventListener("error", function () { v.remove(); }, { once: true });
    media.appendChild(v);
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  });
})();
